import SortActionTypes from './sort-types';

const INITIAL_PROJECT_SORT_STATE = {
    sortSelection: null,
    sortOrder: {
        name: 'Ascending',
        id: 0 
    }
}

const INITIAL_TASK_SORT_STATE = {
    sortSelection: null,
    sortOrder: {
        name: 'Ascending',
        id: 0
    }
}

const INITIAL_STATE = {
    projects: INITIAL_PROJECT_SORT_STATE,
    tasks: INITIAL_TASK_SORT_STATE
}

const sortReducer = (state = INITIAL_STATE, {type,payload}) => {
    switch(type){
        case SortActionTypes.UPDATE_PROJECT_SORT_SELECTION:
            return {
                ...state,
                projects: {
                        ...state.projects,
                        sortSelection: payload
                    }
            }
        case SortActionTypes.UPDATE_PROJECT_SORT_ORDER:
            return{
                ...state,
                projects: {
                        ...state.projects,
                        sortOrder: payload
                    }
            }
        case SortActionTypes.CLEAR_PROJECT_SORT:
            return{
                ...state,
                projects: INITIAL_PROJECT_SORT_STATE
            }
        case SortActionTypes.UPDATE_TASK_SORT_SELECTION:
            return{
                ...state,
                tasks:{
                    ...state.tasks,
                    sortSelection: payload
                }
            }
        case SortActionTypes.UPDATE_TASK_SORT_ORDER:
            return{
                ...state,
                tasks:{
                    ...state.tasks,
                    sortOrder: payload
                }
            }
        case SortActionTypes.CLEAR_TASK_SORT:
            return{
                ...state,
                tasks: INITIAL_TASK_SORT_STATE
            }
        case SortActionTypes.CLEAR_ALL_SORTS:
            return INITIAL_STATE
        default:
            return state;
    }
}

export default sortReducer;